<template>
  <div>
    <main class="l-content">
      <Catalog/>
      <SuperOffer/>
      <PhoneSection/>
    </main>
  </div>
</template>

<script>
  import Catalog from '../components/Catalog'
  import PhoneSection from '@/components/PhoneSection'
  import SuperOffer from '@/components/SuperOffer'


  export default {
    name: 'Delivery',
    components: {
      SuperOffer,
      PhoneSection,
      Catalog,
    }
  }
</script>

<style>

</style>
